module.exports = __webpack_public_path__ + "assets/1e63c2d9867b1a9dacf3648a3787a45d.png";